import { IIdentifiable } from '@/common/models/models'
import { EditorialOffice, IEditorialOffice } from '@/common/models/data/dashboard/staff/editorial-office'
import { IRadioRole, RadioRole } from '@/common/models/data/dashboard/staff/radio-role'
import { IUserBasicData, UserBasicData } from '@/common/models/data/common/user'

interface IStaff extends IIdentifiable {
    user_id: number
    editorial_office_id: number | null
    radio_role_id: number | null
    editorial_college: boolean
    description: string
    photo: string
    archived: boolean

    editorial_office: IEditorialOffice | null
    radio_role: IRadioRole | null
    user: IUserBasicData
}

class Staff implements IStaff {
    id = 0
    user_id = 0
    editorial_office_id: number | null = null
    radio_role_id: number | null = null
    editorial_college = false
    description = ''
    photo = ''
    archived = false

    editorial_office: EditorialOffice | null = null
    radio_role: RadioRole | null = null
    user = new UserBasicData()

    file: File | null = null

    constructor (dto?: IStaff) {
        if (dto) {
            this.id = dto.id
            this.user_id = dto.user_id
            this.editorial_office_id = dto.editorial_office_id
            this.radio_role_id = dto.radio_role_id
            this.editorial_college = dto.editorial_college
            this.description = dto.description
            this.photo = dto.photo
            this.archived = dto.archived

            this.editorial_office = dto.editorial_office ? new EditorialOffice(dto.editorial_office) : null
            this.radio_role = dto.radio_role ? new RadioRole(dto.radio_role) : null
            this.user = new UserBasicData(dto.user)
        }
    }
}

export {
    IStaff, Staff
}
